const CONDITION = 'condition';
const LABEL = 'label';
const TOOLTIP = 'tooltip';
const COLUMN = 'column';

export interface FilterButtonConfigRaw {
  condition: string;
  label: string;
  tooltip: string;
  column: string;
}

export class FilterButtonConfig {
  private readonly rawData: Partial<FilterButtonConfigRaw>;

  private readonly id: string | undefined;

  constructor(
    rawData: Partial<FilterButtonConfigRaw> = {},
    id: string | undefined = undefined
  ) {
    this.rawData = {...rawData};
    this.id = id;
  }

  getId() {
    return this.id;
  }

  getTitle() {
    return this.rawData[TOOLTIP] ? this.rawData[TOOLTIP] : undefined;
  }

  getLabel() {
    return this.rawData[LABEL] ? this.rawData[LABEL] : undefined;
  }

  getColumnId() {
    return this.rawData[COLUMN] ? this.rawData[COLUMN] : undefined;
  }

  getCondition() {
    return this.rawData[CONDITION] ? this.rawData[CONDITION] : undefined;
  }

  isValid() {
    return (
      typeof this.getTitle() !== 'undefined' &&
      typeof this.getLabel() !== 'undefined' &&
      typeof this.getColumnId() !== 'undefined'
    );
  }
}

export default {FilterButtonConfig};
